import React, { useState, useEffect } from 'react';
import {
  Center,
  Box,
  Flex,
  Text,
  Button,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Switch,
  useToast,
  Stack,
  Tooltip,
  Image,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  SimpleGrid,
  Divider,
} from '@chakra-ui/react';
import { Spinner } from '@chakra-ui/react';
import Card from 'components/card/Card';
import ClientAPI from '../../../../api/client';
import ClientConfigAPI from '../../../../api/clientconfig';
import { EditIcon, CloseIcon } from '@chakra-ui/icons';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { usePermissions } from 'contexts/PermissionContext';
import PageError from 'components/nopermission/PageError';
export default function Home() {
  const toast = useToast();
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [clientName, setClientName] = useState(null);
  const [clientPhoneNumber, setClientPhoneNumber] = useState(null);
  const [clientEmail, setClientEmail] = useState(null);
  const [clientStatus, setClientStatus] = useState(null);
  const [twoFactor, setTwoFactor] = useState(null);
  const [goldLocker, setGoldLocker] = useState(null);
  const [savingPlan, setSavingPlan] = useState(null);
  const [tokenSessionTime, setTokenSessionTime] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [backendUrl, setBackendUrl] = useState(null);
  const [frontendUrl, setFrontendUrl] = useState(null);
  const [goldBuyGst, setGoldBuyGst] = useState(null);
  const [goldSellGst, setGoldSellGst] = useState(null);
  const [goldBuySellPriceGap, setGoldBuySellPriceGap] = useState(null);
  const [advanceBook, setAdvanceBook] = useState(null);
  const [userBankRequired, setUserBankRequired] = useState(false);
  const [goldLockerEndTime, setGoldLockerEndTime] = useState(null);
  const [goldLockerStartTime, setGoldLockerStartTime] = useState(null);
  const [minAppVersionAndroid, setMinAppVersionAndroid] = useState(null);
  const [minAppVersionIos, setMinAppVersionIos] = useState(null);
  const { getPermissionsForModule } = usePermissions();
  const [permission, setPermissions] = useState(null);
  const [fetchClientDataError, setFetchClientDataError] = useState(false);
  const [fetchClientConfigDataError, setFetchClientConfigDataError] =
    useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      let clientDetails = await ClientAPI.Get();
      console.log('clientDetails = ', clientDetails);

      clientDetails = clientDetails.data;

      if (clientDetails.status_code === 200 && clientDetails.data) {
        setFetchClientDataError(false);
        setClientName(clientDetails.data.name);
        setClientPhoneNumber(clientDetails.data.phone_number);
        setClientEmail(clientDetails.data.email);
        setClientStatus(clientDetails.data.status);
      } else {
        setFetchClientDataError(true);
      }

      setLoading(false);
    } catch (err) {
      setFetchClientDataError(true);
      console.log(err);
    }
  };

  const FetchClientConfig = async () => {
    try {
      setLoading(true);
      let clientConfigDetails = await ClientConfigAPI.Get();
      console.log('clientConfigDetails = ', clientConfigDetails);
      clientConfigDetails = clientConfigDetails.data;
      if (
        clientConfigDetails.status_code === 200 &&
        clientConfigDetails.data &&
        clientConfigDetails.data.length
      ) {
        setFetchClientConfigDataError(false);
        setTwoFactor(clientConfigDetails.data[0].two_factor);
        setGoldLocker(clientConfigDetails.data[0].gold_locker);
        setSavingPlan(clientConfigDetails.data[0].saving_plan);
        setTokenSessionTime(clientConfigDetails.data[0].token_session_time);
        setLogoUrl(clientConfigDetails.data[0].logo_url);
        setBackendUrl(clientConfigDetails.data[0].backend_url);
        setFrontendUrl(clientConfigDetails.data[0].frontend_url);
        setGoldBuyGst(clientConfigDetails.data[0].gold_buy_gst);
        setGoldSellGst(clientConfigDetails.data[0].gold_sell_gst);
        setGoldBuySellPriceGap(clientConfigDetails.data[0].gold_buy_sell_price_gap);
        setAdvanceBook(clientConfigDetails.data[0].advance_book);
        setUserBankRequired(clientConfigDetails.data[0].user_bank_required);
        setGoldLockerEndTime(clientConfigDetails.data[0].gold_locker_end_time);
        setGoldLockerStartTime(clientConfigDetails.data[0].gold_locker_start_time);
        setMinAppVersionAndroid(clientConfigDetails.data[0].min_app_version_android);
        setMinAppVersionIos(clientConfigDetails.data[0].min_app_version_ios);
      } else {
        setFetchClientConfigDataError(true);
      }
      setLoading(false);
      console.log(backendUrl, frontendUrl);
    } catch (err) {
      setFetchClientConfigDataError(true);
      console.log(err);
    }
  };

  useEffect(() => {
    const permission = getPermissionsForModule([Modules.ClientConfig]);
    setPermissions(permission);
  }, []);

  useEffect(() => {
    if (permission?.read) {
      fetchData();
      FetchClientConfig();
    }
  }, [permission]);

  console.log('Permissions', permission);
  const enable = () => {
    setDisabled(!disabled);
  };
  const disable = () => {
    setDisabled(true);
  };
  const handleNumberInput = (e) => {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
    }
  };
  const hasAllPermissions =
    permission?.read &&
    permission?.create &&
    permission?.update &&
    permission?.delete;

  const handleUpdate = async (onClose, id) => {
    try {
      let request = {
        two_factor: twoFactor,
        gold_locker: goldLocker,
        saving_plan: savingPlan,
        token_session_time: tokenSessionTime,
        logo_url: logoUrl,
        backend_url: backendUrl,
        frontend_url: frontendUrl,
        gold_buy_gst: goldBuyGst,
        gold_sell_gst: goldSellGst,
        gold_buy_sell_price_gap: goldBuySellPriceGap,
        advance_book: advanceBook,
        user_bank_required: userBankRequired,
        gold_locker_end_time: goldLockerEndTime,
        gold_locker_start_time: goldLockerStartTime,
        min_app_version_android: minAppVersionAndroid,
        min_app_version_ios: minAppVersionIos,
      };
      console.log(request);
      const response = await ClientConfigAPI.Update(request);
      console.log(response);
      if (response.data.status_code === 200) {
        toast({
          title: response?.data?.message || 'Successfully Updated',
          status: 'success',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
        setDisabled(true);
        fetchData();
      } else if (response.data.statusCode !== 200) {
        toast({
          title: response?.data?.message || 'Error Updating',
          status: 'error',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  if (!permission?.read) {
    return <NoPermissionsMessage module={Modules.ClientConfig} />;
  }

  return (
    <>
      <Card
        direction='column'
        w='100%'
        px='20px'
        pb='20px'
        mt={{ base: '140px', md: '120px' }}
        overflowX={{ sm: 'scroll', lg: 'hidden' }}>
        <Flex
          alignItems='center'
          justifyContent='space-between'
          mt='20px'
          mb='20px'>
          <Text
            fontSize='2xl'
            fontWeight='700'>
            Client Management
          </Text>
        </Flex>

        {loading ? (
          <Center
            mt={20}
            mb={20}
            width='100%'>
            <Spinner size='xl' />
          </Center>
        ) : (
          <Tabs variant='soft-rounded' colorScheme='brand' mt={5}>
            <TabList>
              <Tab>Client Details</Tab>
              <Tab>Client Configuration</Tab>
            </TabList>
            <TabPanels>
              <TabPanel px={0} py={5}>
                {fetchClientDataError ? (
                  <PageError />
                ) : (
                  <SimpleGrid columns={{ base: 1, md: 2 }} gap='20px'>
                    <FormControl>
                      <FormLabel fontWeight="600"> Name</FormLabel>
                      <Input
                        variant='authSecondary'
                        type='Text'
                        disabled={true}
                        defaultValue={clientName}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="600"> Email</FormLabel>
                      <Input
                        variant='authSecondary'
                        type='Text'
                        disabled={true}
                        defaultValue={clientEmail}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="600">Phone Number</FormLabel>
                      <Input
                        variant='authSecondary'
                        type='Text'
                        disabled={true}
                        defaultValue={clientPhoneNumber}
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="600">Status</FormLabel>
                      <Input
                        variant='authSecondary'
                        type='Text'
                        disabled={true}
                        defaultValue={clientStatus}
                      />
                    </FormControl>
                  </SimpleGrid>
                )}
              </TabPanel>
              <TabPanel px={0} py={5}>
                <Flex
                  alignItems='center'
                  justifyContent='space-between'
                  mb='10px'>
                  <Text
                    fontSize='xl'
                    fontWeight='700'>
                    Configuration Settings
                  </Text>
                  {!fetchClientConfigDataError && (
                    <>
                      {disabled ? (
                        <Tooltip
                          label={
                            !permission?.update
                              ? 'You do not have permission to edit'
                              : undefined
                          }
                          placement='top'
                          shouldWrapChildren
                          isDisabled={hasAllPermissions}
                        >
                          <EditIcon
                            fontSize='xl'
                            onClick={hasAllPermissions ? enable : undefined}
                            cursor={hasAllPermissions ? 'pointer' : 'not-allowed'}
                            color={hasAllPermissions ? 'brand.500' : 'gray.400'}
                          />
                        </Tooltip>
                      ) : (
                        <CloseIcon
                          fontSize='xl'
                          onClick={disable}
                          cursor='pointer'
                        />
                      )}
                    </>
                  )}
                </Flex>
                {fetchClientConfigDataError ? (
                  <PageError />
                ) : (
                  <Flex direction='column'>
                    <Text fontSize="lg" fontWeight="600" mb="15px" mt="15px">Features</Text>
                    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap='20px'>
                      <FormControl display="flex" alignItems="center">
                        <Switch
                          id='two-factor'
                          colorScheme='brand'
                          isChecked={twoFactor}
                          isDisabled={disabled}
                          onChange={(e) => setTwoFactor(e.target.checked)}
                        />
                        <FormLabel htmlFor='two-factor' mb='0' ml='10px' fontWeight="600">
                          Two Factor Enable
                        </FormLabel>
                      </FormControl>
                      <FormControl display="flex" alignItems="center">
                        <Switch
                          id='gold-locker'
                          colorScheme='brand'
                          isChecked={goldLocker}
                          isDisabled={disabled}
                          onChange={(e) => setGoldLocker(e.target.checked)}
                        />
                        <FormLabel htmlFor='gold-locker' mb='0' ml='10px' fontWeight="600">
                          Advance Book Enable
                        </FormLabel>
                      </FormControl>
                      <FormControl display="flex" alignItems="center">
                        <Switch
                          id='saving-plan'
                          colorScheme='brand'
                          isChecked={savingPlan}
                          isDisabled={disabled}
                          onChange={(e) => setSavingPlan(e.target.checked)}
                        />
                        <FormLabel htmlFor='saving-plan' mb='0' ml='10px' fontWeight="600">
                          Saving Plan Enable
                        </FormLabel>
                      </FormControl>
                      <FormControl display="flex" alignItems="center">
                        <Switch
                          id='user-bank'
                          colorScheme='brand'
                          isChecked={userBankRequired}
                          isDisabled={disabled}
                          onChange={(e) => setUserBankRequired(e.target.checked)}
                        />
                        <FormLabel htmlFor='user-bank' mb='0' ml='10px' fontWeight="600">
                          User Bank Required
                        </FormLabel>
                      </FormControl>
                    </SimpleGrid>

                    <Divider my="25px" />

                    <Text fontSize="lg" fontWeight="600" mb="15px">General & Metal Settings</Text>
                    <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap='20px'>
                      <FormControl>
                        <FormLabel fontWeight="600">App Pin Session Time (mins)</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='Number'
                          disabled={disabled}
                          defaultValue={tokenSessionTime}
                          onKeyDown={handleNumberInput}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => setTokenSessionTime(e.target.value)}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel fontWeight="600">Logo URL</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='Text'
                          disabled={disabled}
                          defaultValue={logoUrl}
                          onChange={(e) => setLogoUrl(e.target.value)}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel fontWeight="600">Advance Book (%)</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='Number'
                          disabled={disabled}
                          defaultValue={advanceBook}
                          onKeyDown={handleNumberInput}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => setAdvanceBook(e.target.value)}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel fontWeight="600">Gold Buy GST (%)</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='Number'
                          disabled={disabled}
                          defaultValue={goldBuyGst}
                          onKeyDown={handleNumberInput}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => setGoldBuyGst(e.target.value)}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel fontWeight="600">Gold Sell GST (%)</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='Number'
                          disabled={disabled}
                          defaultValue={goldSellGst}
                          onKeyDown={handleNumberInput}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => setGoldSellGst(e.target.value)}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel fontWeight="600">Gold Buy/Sell Price Gap</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='Number'
                          disabled={disabled}
                          defaultValue={goldBuySellPriceGap}
                          onKeyDown={handleNumberInput}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => setGoldBuySellPriceGap(e.target.value)}
                        />
                      </FormControl>
                    </SimpleGrid>

                    <Divider my="25px" />

                    <Text fontSize="lg" fontWeight="600" mb="15px">Timing, URLs & App Versions</Text>
                    <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap='20px'>
                      <FormControl>
                        <FormLabel fontWeight="600">Gold Locker Start Time</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='time'
                          step='1'
                          disabled={disabled}
                          defaultValue={goldLockerStartTime}
                          onChange={(e) => setGoldLockerStartTime(e.target.value)}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel fontWeight="600">Gold Locker End Time</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='time'
                          step='1'
                          disabled={disabled}
                          defaultValue={goldLockerEndTime}
                          onChange={(e) => setGoldLockerEndTime(e.target.value)}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel fontWeight="600">Back-End URL</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='Text'
                          disabled={disabled}
                          defaultValue={backendUrl}
                          onChange={(e) => setBackendUrl(e.target.value)}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel fontWeight="600">Front-End URL</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='Text'
                          disabled={disabled}
                          defaultValue={frontendUrl}
                          onChange={(e) => setFrontendUrl(e.target.value)}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel fontWeight="600">Min Android App Version</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='Number'
                          disabled={disabled}
                          defaultValue={minAppVersionAndroid}
                          onKeyDown={handleNumberInput}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => setMinAppVersionAndroid(e.target.value)}
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel fontWeight="600">Min iOS App Version</FormLabel>
                        <Input
                          variant={disabled ? 'authNoBorder' : 'auth'}
                          type='Number'
                          disabled={disabled}
                          defaultValue={minAppVersionIos}
                          onKeyDown={handleNumberInput}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => setMinAppVersionIos(e.target.value)}
                        />
                      </FormControl>
                    </SimpleGrid>

                    <Flex mt={8} justifyContent="flex-end">
                      <Button
                        colorScheme='brand'
                        w={{ base: "100%", md: "200px" }}
                        disabled={disabled}
                        onClick={handleUpdate}>
                        Save Changes
                      </Button>
                    </Flex>
                  </Flex>
                )}
              </TabPanel>
            </TabPanels>
          </Tabs>
        )}
      </Card>
    </>
  );
}
